"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const calendar_icon_svg_1 = __importDefault(require("../../../assets/images/icons/calendar-icon.svg"));
const credential_type_svg_1 = __importDefault(require("../../../assets/images/icons/credential-type.svg"));
const expire_date_icon_svg_1 = __importDefault(require("../../../assets/images/icons/expire-date-icon.svg"));
const level_icon_svg_1 = __importDefault(require("../../../assets/images/icons/level-icon.svg"));
const cost_icon_svg_1 = __importDefault(require("../../../assets/images/icons/cost-icon.svg"));
const duration_icon_svg_1 = __importDefault(require("../../../assets/images/icons/duration-icon.svg"));
const react_1 = __importDefault(require("react"));
require("./verifySingleDetail.scss");
const styled_components_1 = __importDefault(require("styled-components"));
const master_1 = require("../../../constants/master");
const react_svg_1 = require("react-svg");
const StyledVerifySingleDetail = styled_components_1.default.div `
  background: ${(props) => props.containerBackgroundColor} !important;

  .customizable-icon {
    width: 11px;
    height: 11px;
    svg {
      width: 11px;
      height: 11px;
    }
    .injected-svg {
      max-height: 10px;
      width: 10px;
      fill: ${(props) => props.containerTextColor}80 !important;
      stroke: none !important;
    }
  }

  .dynamic-text-color {
    color: ${(props) => props.containerTextColor} !important;
  }

  // dynamic-text-color with 50% opacity
  .dynamic-text-color80 {
    color: ${(props) => props.containerTextColor}80 !important;
  }
`;
function VerifySingleDetail(props) {
    const config = (0, master_1.getMasterConfig)();
    const getIcon = () => {
        switch (props.type) {
            case "cost":
                return cost_icon_svg_1.default;
            case "issueDate":
                return calendar_icon_svg_1.default;
            case "credentialType":
                return credential_type_svg_1.default;
            case "duration":
                return duration_icon_svg_1.default;
            case "level":
                return level_icon_svg_1.default;
            case "expireDate":
                return expire_date_icon_svg_1.default;
            default:
                return "";
        }
    };
    return (react_1.default.createElement(StyledVerifySingleDetail, { containerTextColor: config.containerTextColor, containerBackgroundColor: config.containerBackgroundColor, className: "verify-single-detail" },
        react_1.default.createElement("div", { className: "icon-part" },
            react_1.default.createElement(react_svg_1.ReactSVG, { src: getIcon(), className: "customizable-icon detail-icon", wrapper: "svg" })),
        react_1.default.createElement("div", { className: "text-part" },
            react_1.default.createElement("span", { className: "detail-label dynamic-text-color80" }, props.label),
            react_1.default.createElement("span", { className: "detail-text dynamic-text-color" }, props.text))));
}
exports.default = VerifySingleDetail;
